'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TestimonialCardProps {
  name: string;
  role: string;
  company: string;
  image: string;
  alt: string;
  rating: number;
  testimonial: string;
  stayDuration: string;
  apartmentType: string;
}

export default function TestimonialCard({
  name,
  role,
  company,
  image,
  alt,
  rating,
  testimonial,
  stayDuration,
  apartmentType,
}: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-2xl shadow-subtle hover:shadow-elevated transition-all duration-500 p-8 border border-border">
      <div className="flex items-start space-x-4 mb-6">
        <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-accent">
          <AppImage src={image} alt={alt} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-primary text-lg">{name}</h4>
          <p className="text-sm text-text-secondary">{role}</p>
          <p className="text-sm text-accent font-medium">{company}</p>
        </div>
        <div className="flex space-x-1">
          {[...Array(5)].map((_, index) => (
            <Icon
              key={index}
              name="StarIcon"
              size={18}
              variant={index < rating ? 'solid' : 'outline'}
              className={index < rating ? 'text-accent' : 'text-muted-foreground'}
            />
          ))}
        </div>
      </div>

      <p className="text-text-secondary leading-relaxed mb-6 italic">"{testimonial}"</p>

      <div className="flex items-center justify-between pt-6 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="HomeIcon" size={16} className="text-primary" />
          <span>{apartmentType}</span>
        </div>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="CalendarIcon" size={16} className="text-primary" />
          <span>{stayDuration}</span>
        </div>
      </div>
    </div>
  );
}